import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectWeatherReportRequestFailure({ uuid }) {
      const state = getState().find((req) => req.project.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isEditProjectWeatherReportRequestPending({ uuid }) {
      const state = getState().find((req) => req.project.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isEditProjectWeatherReportRequestSuccess({ uuid }) {
      const state = getState().find((req) => req.project.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
